import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const CustomOptionDropdown = (props: DropdownProps<server.dto.DropdownOption, string>) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    options={props.options}
    getLabel={option => option.value}
    getValue={option => option.key}
    excludeKeys={props.excludeKeys}
    config={props.config}
  />;
};

export default CustomOptionDropdown;
